import React, { useState, useEffect } from "react";
import TabBasic from "./components/TabBasic";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import TabAdvanced from "./components/tab_advanced/TabAdvanced";
import Header from "./components/Header";
import Speed from "./components/Speed";
import Glossary from "./components/Glossary";
import {
  insertCertificates,
  insertEWCJobs,
  insertOffenseCategoryTypes,
  insertPrograms,
} from "./components/tab_advanced/tabAdvancedSlice";
import { useDispatch } from "react-redux";
import background from "./background.jpg";
import COERequestListBox from "./components/coe/COERequestListBox";
import COESubscribeBox from "./components/coe/COESubscribeBox";
import COEUnregisterBox from "./components/coe/COEUnregisterBox";
import COETransferEmailBox from "./components/coe/COETransferEmailBox";
import { env, isIE } from "./environment";

function App() {
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 1245px)").matches
  );

  const dispatch = useDispatch();

  // APP MOUNTED
  useEffect(() => {
    // Allow scroll, this will be changed when coe is displayed
    document.body.style.overflow = "auto";

    const handler = (e) => setMatches(e.matches);
    window.matchMedia("(min-width: 1245px)").addListener(handler);

    // GET certificate, program, ewc and offense category for dropdowns
    fetch(env + "inmateSearchAdvanced.do?method=certificates")
      .then((response) => response.json())
      .then((data) => {
        dispatch(
          insertCertificates(
            data.sort((a, b) => a.description.localeCompare(b.description))
          )
        );
      })
      .catch((e) => console.log(e));
    fetch(env + "inmateSearchAdvanced.do?method=ewc")
      .then((response) => response.json())
      .then((data) =>
        dispatch(
          insertEWCJobs(
            data.sort((a, b) => a.description.localeCompare(b.description))
          )
        )
      )
      .catch((e) => console.log(e));
    fetch(env + "inmateSearchAdvanced.do?method=programs")
      .then((response) => response.json())
      .then((data) => {
        dispatch(
          insertPrograms(
            data.sort((a, b) => a.description.localeCompare(b.description))
          )
        );
      })
      .catch((e) => console.log(e));
    fetch(env + "inmateSearchAdvanced.do?method=offenseCategoryTypes")
      .then((response) => response.json())
      .then((data) =>
        dispatch(
          insertOffenseCategoryTypes(
            data.sort((a, b) => a.description.localeCompare(b.description))
          )
        )
      )
      .catch((e) => console.log(e));
  });
  return (
    // Background
    <div
      className="bg-blue-dark min-h-screen flex bg-no-repeat top-of-app"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "1750px",
        backgorundColor: "#00123b",
      }}
    >
      <div
        className="absolute   m-5 p-5 rounded-md shadow-md  border-4 border-solid"
        style={{
          width: "800px",
          zIndex: "100",
          top: "40%",
          left: "50%",
          color: "white",
          backgroundColor: "#EF4444",
          transform: "translate(-50%, -50%)",
          display: isIE ? "" : "none",
        }}
      >
        <p className="text-lg">
          The South Carolina Department of Corrections Incarcerated Inmate
          Search has been updated to include features that only function on
          modern browsers such as:
        </p>
        <ul className="text-lg">
          <li className="ml-5 list-disc">Microsoft's Edge</li>
          <li className="ml-5  list-disc">Google Chrome</li>
          <li className="ml-5  list-disc">Mozilla Firefox</li>
          <li className="ml-5  list-disc">Apple's Safari</li>
        </ul>
      </div>

      <COESubscribeBox />
      <COEUnregisterBox />
      <COERequestListBox />
      <COETransferEmailBox />
      {/* Gray outline */}
      <div
        className=" bg-gray-300 mx-auto "
        style={{ width: "1250px", display: isIE ? "none" : "" }}
      >
        {/* Main content */}
        <div
          className="bg-white m-auto divide-solid divide-y-4 py-5 px-6"
          style={{
            width: matches ? "99%" : "100%",
            height: "100%",
            backgroundColor: "white",
          }}
        >
          <Router basename=".">
            <Header />

            <Switch>
              <Route path="/scdc-public/" exact component={TabBasic} />
              <Route path="/scdc-public/advanced" component={TabAdvanced} />
              {/* <Route path="/scdc-public/speed" component={Speed} />
              <Route path="/scdc-public/glossary.do" /> */}
              <Route path="/scdc-public/glossary" component={Glossary} />
            </Switch>
          </Router>
        </div>
      </div>
    </div>
  );
}

export default App;
